/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type CreateGooseGameStoreItemMutationVariables = Types.Exact<{
  name: Types.Scalars["String"];
  eventId: Types.Scalars["Float"];
  description?: Types.Maybe<Types.Scalars["String"]>;
  imageUrl?: Types.Maybe<Types.Scalars["String"]>;
  pointCost: Types.Scalars["Float"];
  quantityAvailable: Types.Scalars["Float"];
  userRedemptionLimit: Types.Scalars["Float"];
}>;

export type CreateGooseGameStoreItemMutation = {
  createGooseGameStoreItem: Pick<
    Types.GooseGameItem,
    "id" | "name" | "description" | "is_sold_out" | "user_redemption_limit"
  >;
};

export const CreateGooseGameStoreItemDocument = gql`
  mutation CreateGooseGameStoreItem(
    $name: String!
    $eventId: Float!
    $description: String
    $imageUrl: String
    $pointCost: Float!
    $quantityAvailable: Float!
    $userRedemptionLimit: Float!
  ) {
    createGooseGameStoreItem(
      name: $name
      event_id: $eventId
      description: $description
      image_url: $imageUrl
      point_cost: $pointCost
      quantity_available: $quantityAvailable
      user_redemption_limit: $userRedemptionLimit
    ) {
      id
      name
      description
      is_sold_out
      user_redemption_limit
    }
  }
`;

/**
 * __useCreateGooseGameStoreItemMutation__
 *
 * To run a mutation, you first call `useCreateGooseGameStoreItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGooseGameStoreItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGooseGameStoreItemMutation, { data, loading, error }] = useCreateGooseGameStoreItemMutation({
 *   variables: {
 *      name: // value for 'name'
 *      eventId: // value for 'eventId'
 *      description: // value for 'description'
 *      imageUrl: // value for 'imageUrl'
 *      pointCost: // value for 'pointCost'
 *      quantityAvailable: // value for 'quantityAvailable'
 *      userRedemptionLimit: // value for 'userRedemptionLimit'
 *   },
 * });
 */
export function useCreateGooseGameStoreItemMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateGooseGameStoreItemMutation,
    CreateGooseGameStoreItemMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    CreateGooseGameStoreItemMutation,
    CreateGooseGameStoreItemMutationVariables
  >(CreateGooseGameStoreItemDocument, baseOptions);
}
export type CreateGooseGameStoreItemMutationHookResult = ReturnType<
  typeof useCreateGooseGameStoreItemMutation
>;
export type CreateGooseGameStoreItemMutationResult =
  ApolloReactCommon.MutationResult<CreateGooseGameStoreItemMutation>;
export type CreateGooseGameStoreItemMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateGooseGameStoreItemMutation,
    CreateGooseGameStoreItemMutationVariables
  >;
